import { LocalStorageService } from './../../core/services/local-storage.service';
import { ContactService } from './../../core/services/contact/contact.service';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  emailSended,
  maxSizeFile,
  serverError,
} from './../../core/models/messages';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs';
import { ReCaptchaService } from '@shared/services/reCaptcha.service';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.css'],
})
export class ContactUsComponent {
  contactForm!: FormGroup;
  currentUser: any;
  id: any;
  filtered: any;
  submitted = false;
  showResetButtons: boolean = true;
  types = [
    { value: 'Technique', id: '1' },
    { value: 'Service client', id: '2' },
    { value: 'Réclamation', id: '3' },
  ];
  fileName: string = '';
  selected: any = this.types[0];
  file: any;
  listContactNames: any;
  fileError: string = '';
  fileExtention: string = '';
  constructor(
    private contactService: ContactService,
    private spinner: NgxSpinnerService,
    private formBuilder: FormBuilder,
    private toastrService: ToastrService,
    private localStorageService: LocalStorageService,
    private reCaptchaService: ReCaptchaService,
  ) {}
  toolbarOptions = [
    ['bold', 'italic', 'underline'], // toggled buttons
    [{ header: 1 }, { header: 2 }], // custom button values
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ indent: '-1' }, { indent: '+1' }],
    [{ color: [] }, { background: [] }], // outdent/indent
    ['clean'] // remove formatting button
  ];

  ngOnInit() {
    const connectedUser = JSON.parse(this.localStorageService.getData('UserInfo') || '{}')    
    this.id = connectedUser?.company?.uuid
    this.contactFormGroup();

    this.getContactNames();

  }
  resetTypeField() {
    this.f['type'].setValue(null);
  }

  contactFormGroup(data?: any) {
    this.contactForm = this.formBuilder.group({
      mailingAdmin_id: [
        data ? data.mailingAdmin_id : null,
        Validators.required,
      ],
      object: ['', [Validators.required, Validators.maxLength(100)]],
      subject: ['', Validators.required],
      user_id: [''],
      file: [''],
    });
  }
  resetCV() {
    const inputFile = document.getElementById('cv') as HTMLInputElement;
    if (inputFile) {
      inputFile.value = '';
      this.fileExtention = '';
      this.fileError = '';
    }
    this.fileName = '';
    this.showResetButtons = true;
  }
  getContactNames() {
    this.spinner.show();
    this.contactService
      .getNamesForContactWegestu()
      .pipe(finalize(() => this.spinner.hide()))
      .subscribe(
        (res: any) => {
          this.listContactNames = res?.data;
          console.log('data listOfMonths ', this.listContactNames);
        },
        (error) => {
          console.error('Error fetching listOfMonths:', error);
        }
      );
  }

  onFileChange(event: Event) {
    const fileInput = event.target as HTMLInputElement;
    if (fileInput.files && fileInput.files[0]) {
      const file = fileInput.files[0];
      this.file = file;
      this.fileName = this.file.name;
      console.log('filename', this.fileName);
      if (this.file) {
        const allowedExtensions = ['.pdf', '.docx', '.doc','.jpg','.png'];
        const fileExtension = this.file.name
          .toLowerCase()
          .substr(this.file.name.lastIndexOf('.'));

        if (!allowedExtensions.includes(fileExtension)) {
          this.fileExtention = 'Format fichier non compatible !';
        } else if (this.file.size > maxSizeFile) {
          this.fileError =
            'Le fichier à importer ne doit pas depasser 2 méga !';
        } else {
          this.fileError = '';
          this.fileExtention = '';
        }
        console.log('file', this.file);
      }
      this.contactForm.get('file')?.setValue(this.file);
    }
  }

  contactWegestU() {

    this.reCaptchaService.executeAction('contactWgu').then(token => {
    this.spinner.show();
    this.submitted = true;
    this.contactForm.get('user_id')?.setValue(this.id);
    console.log('contactForm', this.contactForm.value);
    const formData = new FormData();
    formData.append(
      'mailingAdmin_id',
      this.contactForm.get('mailingAdmin_id')?.value
    );
    formData.append('object', this.contactForm.get('object')?.value);
    formData.append('subject', this.contactForm.get('subject')?.value);
    formData.append('user_id', this.id);
    formData.append('file', this.file);
    formData.append('recaptchaToken', token);
    const formDataObject: { [key: string]: any } = {};
    formData.forEach((value, key) => {
      formDataObject[key] = value;
    });
    console.log('contact wegestu contact-us', this.contactForm.value);
    console.log('formDataObject++', formDataObject);
    this.contactService
      .contactWegestU(formData)
      .pipe()
      .subscribe({
        next: (res) => {
          this.toastrService.success(emailSended);
          this.onReset();
          this.fileName = '';
          this.fileExtention = '';
          this.spinner.hide();
        },
        error: (err) => {
          this.spinner.hide();
          if (err?.error) {
            this.toastrService.error(serverError);
          }
        },
      });
    }).catch(err => {
      this.spinner.hide();
      this.toastrService.error('reCAPTCHA verification failed. Please try again.');
    });
  }

  get f() {
    return this.contactForm.controls;
  }

  onSelectChange(event: any) {
    console.log('Selected:', event);
  }

  onReset() {
    this.submitted = false;
    this.contactForm.reset();
    this.contactForm.get('file')?.setValue('');
  }
}
